import ApiPermisos from './../../services/apiPermisos'

export default {
  namespaced: true,
  state: {
    errorMsj: '',
    categories: [],
    rightPetition: [],
    loading: false,
  },
  getters: {},
  mutations: {
    setCategories: (state, categories) => {
      state.categories = categories;
    },
    setRightPetition: (state, rightPetition) => {
      state.rightPetition = [];
      state.rightPetition = rightPetition;
    },
    setLoading: (state, loading) => {
      state.loading = loading;
    },
  },
  actions: {    
    //Trae la informacion de las categorias del derecho de petición
    actGetCategories: async ({
      commit
    }) => {
        commit('setLoading', true);
        let response = await ApiPermisos.getCategories();
        if (response.error) {
            return response.error;
        }
        else{
          commit('setLoading', false);
          commit('setCategories', response);
        }
        return true;
    },

    // Guarda un derecho de petición
    actSaveRightPetition: async ({
      commit
    }, data) => {
      commit('setLoading', true);
      let response = await ApiPermisos.saveRightPetition(data);
      commit('setLoading', false);
      if (response.error) {
        commit('errorMsj', response);
        return response.error;
      }
      else{
        return response;
      }
    },  

    //Trae listado de derechos de petición
    actGetRightPetition: async ({
      commit
    }, data) => {
        commit('setLoading', true);
        let response = await ApiPermisos.getRightPetition(data);
        if (response.error) {
            return response.error;
        }
        else{
          commit('setLoading', false);
          commit('setRightPetition', response);
        }
        return true;
    },
  },
}